(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["notify-me-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var overlay = document.querySelector('[data-notify-overlay]');
    var modal = document.querySelector('[data-notify-modal]');
    var closeBtn = document.querySelector('[data-notify-close]');
    var openTriggers = document.querySelectorAll('[data-notify-open]');
    var form = document.querySelector('[data-notify-form]');
    if (!overlay || !modal || !form) return;

    var titleEl = document.querySelector('[data-notify-title]');
    var descriptionEl = document.querySelector('[data-notify-description]');
    var successEl = document.querySelector('[data-notify-success]');
    var phoneInput = form.querySelector('[data-notify-phone]');
    var fieldsWrap = form.querySelector('[data-notify-fields]');
    var consentEl = form.querySelector('[data-notify-consent]');
    var errorEl = form.querySelector('[data-notify-error]');
    var submitBtn = form.querySelector('[data-notify-submit]');

    var autoCloseTimer = null;

    function resetFormDisplay() {
      clearTimeout(autoCloseTimer);
      if (titleEl) titleEl.hidden = false;
      if (descriptionEl) descriptionEl.hidden = false;
      if (successEl) successEl.hidden = true;
      form.hidden = false;
      errorEl.textContent = '';
    }

    function showThankYou() {
      if (titleEl) titleEl.hidden = true;
      if (descriptionEl) descriptionEl.hidden = true;
      form.hidden = true;
      if (successEl) successEl.hidden = false;
      // A regular thank-you, not an open-ended modal — close itself and
      // hand control back so the size selector can revert (see
      // rachawk:notify-form-closed in product-info.liquid).
      autoCloseTimer = setTimeout(closeNotifyModal, 2000);
    }

    function openNotifyModal() {
      resetFormDisplay();
      overlay.classList.add('is-open');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeNotifyModal() {
      clearTimeout(autoCloseTimer);
      overlay.classList.remove('is-open');
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.dispatchEvent(new CustomEvent('rachawk:notify-form-closed'));
    }

    openTriggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openNotifyModal();
      });
    });
    closeBtn.addEventListener('click', closeNotifyModal);
    overlay.addEventListener('click', closeNotifyModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeNotifyModal();
    });

    var errRequired = form.dataset.msgErrorRequired;
    var errPhoneInvalid = form.dataset.msgErrorPhoneInvalid;

    function isValidPhone(value) {
      var digits = value.replace(/\D/g, '');
      return digits.length >= 8 && digits.length <= 15;
    }

    var productId = form.dataset.productId;
    var productHandle = form.dataset.productHandle;

    function currentVariantId() {
      // Prefer the live selection tracked by the Add to cart form (updates as
      // the shopper switches size/variant); fall back to the variant this
      // page was rendered with.
      var idInput = document.querySelector('[data-variant-id]');
      return idInput ? idInput.value : form.dataset.fallbackVariantId;
    }
    function currentSizeLabel() {
      // Not every product has a size option — null is fine, the backend
      // just leaves that column blank.
      var checked = document.querySelector('.product-info__size-btn input:checked');
      return checked ? checked.value : null;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.textContent = '';

      var phone = phoneInput.value.trim();

      if (!phone) {
        errorEl.textContent = errRequired;
        return;
      }
      if (!isValidPhone(phone)) {
        errorEl.textContent = errPhoneInvalid;
        return;
      }

      var eventId = 'notify_' + Date.now() + '_' + Math.random().toString(36).slice(2);
      var variantId = currentVariantId();
      var size = currentSizeLabel();

      // Optimistic UI: the shopper sees the thank-you immediately rather
      // than waiting on the round trip (Apps Script's redirect chain adds
      // real latency). The request still goes out in the background; a
      // failure is only logged, not surfaced, since by this point we've
      // already told the shopper it worked.
      showThankYou();

      // Calls the Apps Script backend directly rather than through a Shopify
      // App Proxy. No explicit Content-Type header on purpose: setting
      // "application/json" makes this a non-simple CORS request, which
      // triggers a preflight OPTIONS request that Apps Script web apps
      // don't handle. Omitting it lets fetch default to
      // "text/plain;charset=UTF-8" (CORS-safelisted, no preflight) while
      // the body is still valid JSON text — doPost() in apps-script.gs
      // reads e.postData.contents and JSON.parse()s it regardless of the
      // declared content type.
      fetch(form.dataset.backendUrl, {
        method: 'POST',
        body: JSON.stringify({
          phone: phone,
          size: size,
          product_id: productId,
          product_handle: productHandle,
          variant_id: variantId,
          event_id: eventId,
          event_source_url: window.location.href
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('notify-subscribe request failed');
          return res.json().catch(function () { return {}; });
        })
        .then(function (data) {
          if (data && data.ok === false) throw new Error(data.error || 'notify-subscribe request failed');
        })
        .catch(function (err) {
          console.error('notify-subscribe failed:', err);
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["out-of-stock-sheet"] && !Shopify.designMode) return;
  try {
    (function () {
    var overlay = document.querySelector('[data-oos-overlay]');
    var sheet = document.querySelector('[data-oos-sheet]');
    var titleEl = document.querySelector('[data-oos-title]');
    var notInterestedBtn = document.querySelector('[data-oos-not-interested]');
    var notifyBtn = document.querySelector('[data-oos-notify]');
    if (!overlay || !sheet || !titleEl) return;

    var titleTemplate = titleEl.textContent;
    var confirmed = false;

    function openSheet(label) {
      confirmed = false;
      titleEl.textContent = titleTemplate.replace('{size}', label);
      overlay.classList.add('is-open');
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeSheet() {
      overlay.classList.remove('is-open');
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (!confirmed) {
        document.dispatchEvent(new CustomEvent('rachawk:oos-sheet-cancel'));
      }
    }

    document.addEventListener('rachawk:oos-sheet-open', function (e) {
      openSheet(e.detail && e.detail.label ? e.detail.label : '');
    });

    if (notInterestedBtn) {
      notInterestedBtn.addEventListener('click', closeSheet);
    }
    if (notifyBtn) {
      notifyBtn.addEventListener('click', function () {
        confirmed = true;
        document.dispatchEvent(new CustomEvent('rachawk:oos-sheet-confirm'));
        closeSheet();
      });
    }
    overlay.addEventListener('click', closeSheet);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
